<div [ngClass]="getWeight()">
  {{weight}}
</div>
